import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerMemo {
    customer_memo_idx: number;
    member_name: string;
    customer_memo: string;
    reg_date: string;
}

interface GetCustomerMemoResponse {
    data: CustomerMemo[];
}

export const useGetCustomerMemo = (customerId: number): UseQueryResult<GetCustomerMemoResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerMemoResponse, Error>({
        queryKey: ["getCustomerMemo", customerId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_customer_memo.replace(":customer_idx", customerId.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
